import { Inject, Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { AuthService } from '../services/auth.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {
  constructor(
    private authService: AuthService,
    private router: Router
  ) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {

    if (this.authService.isAuthenticated()) {
      let role: string = this.authService.getCurrentUser()?.['role'] || '';
      
      if(role) {
        if(role == "admin" && (route.data['role'] == "ROLE_TENANT" || route.data['role'] == "ROLE_ACCOUNTING") ) {
          this.router.navigate(['/admin']);
          return false;
        }

        if(role == "tenant" && (route.data['role'] == "ROLE_ADMIN" || route.data['role'] == "ROLE_ACCOUNTING") ) {
          this.router.navigate(['/tenant']);
          return false;
        }

        if(role == "accounting" && (route.data['role'] == "ROLE_TENANT" || route.data['role'] == "ROLE_ADMIN") ) {
          this.router.navigate(['/accounting']);
          return false;
        }
      }

      return true;
    } else {
      
      // Save the attempted URL so we can redirect after login
      this.authService.redirectUrl = state.url;

      this.router.navigate(['/login']);
      return false;
    }
  }
}

@Injectable({
  providedIn: 'root'
})
export class RoleGuard implements CanActivate {
  constructor(
    private authService: AuthService,
    private router: Router
  ) {}

  canActivate(): boolean {
    const user = this.authService.getCurrentUser();
    if (user) {
      return true;
    } else {
      this.router.navigate(['/login']);
      return false;
    }
  }
}